/** GENERATED by scripts/fetch-assets.ts. Do not edit by hand. */
export const ASSETS: ReadonlyMap<string, string> = new Map([
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/100/0d8a4ea6417d4b179110f1a981f9147f.jpg?v=250703010154",
    "/media/0d8a4ea6417d4b179110f1a981f9147f-86d0cc4c.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/100/1d61daf71a7241fd8ab3084050c04823.jpg?v=250703010154",
    "/media/1d61daf71a7241fd8ab3084050c04823-59a1399d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/100/697e3a049f3f4015a72f9528d8e51872.jpg?v=250703010154",
    "/media/697e3a049f3f4015a72f9528d8e51872-fc20fed8.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/100/c4f4437f79f04139a5f098137ec7d66b.jpg?v=250703010154",
    "/media/c4f4437f79f04139a5f098137ec7d66b-3ff7e3f6.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/100/cd2ee3b1c3b348379535a0aad67ddc42.jpg?v=250703010154",
    "/media/cd2ee3b1c3b348379535a0aad67ddc42-c3edf7a0.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/100/d0a18719b7044f7dbd4c919c8b950589.jpg?v=250703010154",
    "/media/d0a18719b7044f7dbd4c919c8b950589-b857459b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/04716A45626D1E12.png?v=250703010154",
    "/media/04716A45626D1E12-29ec97ff.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/0F98C039B724A853.png?v=250703010154",
    "/media/0F98C039B724A853-2fca686b.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/152E12E122CDE385.png?v=250703010154",
    "/media/152E12E122CDE385-da8cbd1e.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/3A149A20A75A1DC0.png?v=250703010154",
    "/media/3A149A20A75A1DC0-33a4e46e.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/4EA728CCA6B6FC09.png?v=250703010154",
    "/media/4EA728CCA6B6FC09-c51b7335.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/54D0D2396C56177A.png?v=250703010154",
    "/media/54D0D2396C56177A-be74365d.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/5725A39127D77C9E.png?v=250703010154",
    "/media/5725A39127D77C9E-2907c854.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/593B2B3A052B2267.png?v=250703010154",
    "/media/593B2B3A052B2267-1cc0dd91.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/A53B03EEAB341AA6.png?v=250703010154",
    "/media/A53B03EEAB341AA6-ea9f46f6.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/CED4560517A01D20.png?v=250703010154",
    "/media/CED4560517A01D20-a41ffe38.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/DCE29CE63116AF15.png?v=250703010154",
    "/media/DCE29CE63116AF15-6700e006.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/EAC5684E01EF38C7.png?v=250703010154",
    "/media/EAC5684E01EF38C7-d8560ea8.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1083-513/F4B79DF910737939.png?v=250703010154",
    "/media/F4B79DF910737939-fa1639b5.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/10961885107A0B39.pdf?v=250703010154",
    "/docs/10961885107A0B39-69c02185.pdf",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1280/0c84de18353a42cbabf54361ae6dcb58.jpg?v=250703010154",
    "/media/0c84de18353a42cbabf54361ae6dcb58-00b6bcd4.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1280/8aec0ab1552e4445a007a40fddaef485.jpg?v=250703010154",
    "/media/8aec0ab1552e4445a007a40fddaef485-09f6204b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/1476A716728DDF53.pdf?v=250703010154",
    "/docs/1476A716728DDF53-42ebb7f2.pdf",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/0467ad7d81794bfe8af710dc46ee89ca.jpg?v=250703010154",
    "/media/0467ad7d81794bfe8af710dc46ee89ca-5047b20f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/12b7db742cbf4ddeb0d0fd6bc5555c60.jpg?v=250703010154",
    "/media/12b7db742cbf4ddeb0d0fd6bc5555c60-e9bbe48b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/390a53c08b9d423abab19d3f49f7fc42.jpg?v=250703010154",
    "/media/390a53c08b9d423abab19d3f49f7fc42-ac7d363d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/3e9e08e3da3d4bccb55d233515360a92.jpg?v=250703010154",
    "/media/3e9e08e3da3d4bccb55d233515360a92-9afe7b48.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/44c9c19907204f98895a6fcf91cdc200.jpg?v=250703010154",
    "/media/44c9c19907204f98895a6fcf91cdc200-9c00727e.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/486884944d9e49399c5172ca29c45dba.jpg?v=250703010154",
    "/media/486884944d9e49399c5172ca29c45dba-1d5d9dc7.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/6661fee08a1a470f823439d90866c0e6.jpg?v=250703010154",
    "/media/6661fee08a1a470f823439d90866c0e6-a9f9489c.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/70333c4e5c3845ee93fba76d743baf1b.jpg?v=250703010154",
    "/media/70333c4e5c3845ee93fba76d743baf1b-2e1586cf.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/778602c5241645d498fdff5c6aeac0c6.jpg?v=250703010154",
    "/media/778602c5241645d498fdff5c6aeac0c6-e3b6b3d4.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/84d7f4d25b9d4b90a6b8c9da34111faa.jpg?v=250703010154",
    "/media/84d7f4d25b9d4b90a6b8c9da34111faa-e3bcbe23.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/8866500aeb3d4e5db12fe218eae8d14e.jpg?v=250703010154",
    "/media/8866500aeb3d4e5db12fe218eae8d14e-7c4ea227.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/89076886b05c4b5d95b78f9cc87d9691.jpg?v=250703010154",
    "/media/89076886b05c4b5d95b78f9cc87d9691-e88418f6.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/a1d92356b76b42e1a289b85f3ebf26dc.jpg?v=250703010154",
    "/media/a1d92356b76b42e1a289b85f3ebf26dc-d0c0abbd.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/a8d1635aace34039a451b9188ecfaadc.jpg?v=250703010154",
    "/media/a8d1635aace34039a451b9188ecfaadc-22eda4a7.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/a9dbe6631bc2406ea6bc370b77cf5728.jpg?v=250703010154",
    "/media/a9dbe6631bc2406ea6bc370b77cf5728-71b7771a.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/ad82cb2f0bfb454fb42955405c4d3c41.jpg?v=250703010154",
    "/media/ad82cb2f0bfb454fb42955405c4d3c41-28fd7d6d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/b82631251eb54331b0afe1a2fcbbefe8.jpg?v=250703010154",
    "/media/b82631251eb54331b0afe1a2fcbbefe8-422e6098.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/b9caf17df5824cfea777eaaf7e147751.jpg?v=250703010154",
    "/media/b9caf17df5824cfea777eaaf7e147751-60225d74.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/bce9200abf7e443f9c2f3aeeb1750e84.jpg?v=250703010154",
    "/media/bce9200abf7e443f9c2f3aeeb1750e84-5671c552.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/bfd4891118eb4ad6b1e35c42db544e41.jpg?v=250703010154",
    "/media/bfd4891118eb4ad6b1e35c42db544e41-44c52c2b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/c9b4ee71218547c39666985be1076515.jpg?v=250703010154",
    "/media/c9b4ee71218547c39666985be1076515-e2200a8f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/cb3d358196024991a7e0523a6748fb73.jpg?v=250703010154",
    "/media/cb3d358196024991a7e0523a6748fb73-6dda2c6e.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/d6f67d54dc4942cba2b040ee3c9137d4.jpg?v=250703010154",
    "/media/d6f67d54dc4942cba2b040ee3c9137d4-5c034362.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/f34d1aa71e4d41edac55300d2b3776e0.jpg?v=250703010154",
    "/media/f34d1aa71e4d41edac55300d2b3776e0-2329218e.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/2a60e601f97e4a6a8f69c34e2219312e.jpg?v=250703010154",
    "/media/2a60e601f97e4a6a8f69c34e2219312e-690444d0.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/37800c5479144e8884e07c3c7127a6e5.jpg?v=250703010154",
    "/media/37800c5479144e8884e07c3c7127a6e5-24dca4a2.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/439125b625d7432ca10d88364f32b6ff.jpg?v=250703010154",
    "/media/439125b625d7432ca10d88364f32b6ff-fdb7a510.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/47cc57ed9b514ce2bb783666b1633cb4.jpg?v=250703010154",
    "/media/47cc57ed9b514ce2bb783666b1633cb4-90f21e12.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/5a55da243b4540149e06ffc5a0bf64e0.jpg?v=250703010154",
    "/media/5a55da243b4540149e06ffc5a0bf64e0-1f40fd71.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/64513fad5c4e478bbc61f8cc6e29bc91.jpg?v=250703010154",
    "/media/64513fad5c4e478bbc61f8cc6e29bc91-696b934b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/70bd109c4e9647f2b5ee6671b4bd35de.jpg?v=250703010154",
    "/media/70bd109c4e9647f2b5ee6671b4bd35de-d7ed0fb3.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/89460d1756f2494e93b341aeb5ca1944.jpg?v=250703010154",
    "/media/89460d1756f2494e93b341aeb5ca1944-ecadfdfe.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/92cf7bb159bd49b3a0d9a32fb69e85e2.jpg?v=250703010154",
    "/media/92cf7bb159bd49b3a0d9a32fb69e85e2-7a7c9bde.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/ba45b9fba88743399101ba9410f9cd87.jpg?v=250703010154",
    "/media/ba45b9fba88743399101ba9410f9cd87-aa992719.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/d4defa8ce195444b9c585bec8d55ad6f.jpg?v=250703010154",
    "/media/d4defa8ce195444b9c585bec8d55ad6f-bf6325ff.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/e66e268a55584048af774e822a0dd640.jpg?v=250703010154",
    "/media/e66e268a55584048af774e822a0dd640-7b0633c6.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/00394aeb93614191bffe5546ddc7c940.jpg?v=250703010154",
    "/media/00394aeb93614191bffe5546ddc7c940-985d031d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/1511e1fee1c04250aa2a3e21d6a5cc01.jpg?v=250703010154",
    "/media/1511e1fee1c04250aa2a3e21d6a5cc01-349dca6f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/3bd98769a0bf4458a5b8c6ba7aeb608d.jpg?v=250703010154",
    "/media/3bd98769a0bf4458a5b8c6ba7aeb608d-d247fef3.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/449bc87b61444b43988b8190de3084bd.jpg?v=250703010154",
    "/media/449bc87b61444b43988b8190de3084bd-b78967a4.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/47e97817b1c745e4ac18abb3457a19cb.jpg?v=250703010154",
    "/media/47e97817b1c745e4ac18abb3457a19cb-903c25a9.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/502d22328dc7408a92b9fde9854d8419.jpg?v=250703010154",
    "/media/502d22328dc7408a92b9fde9854d8419-7bd1aa16.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/56942b42ead146f49bfcbbfd9119d330.jpg?v=250703010154",
    "/media/56942b42ead146f49bfcbbfd9119d330-91bdeae2.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/5ae7beb3142340669e72c210f364836f.jpg?v=250703010154",
    "/media/5ae7beb3142340669e72c210f364836f-35b473a1.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/6148ae3f233b4f01a45dcb9dd22e9fdc.jpg?v=250703010154",
    "/media/6148ae3f233b4f01a45dcb9dd22e9fdc-75301790.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/691c24b4ec924c22a8edf4d2518d87e2.jpg?v=250703010154",
    "/media/691c24b4ec924c22a8edf4d2518d87e2-476320a2.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/797d62d8a8544c2baa23dec73528ec83.jpg?v=250703010154",
    "/media/797d62d8a8544c2baa23dec73528ec83-c7ff7d49.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/7d0a2db2dcb347a38175d284849cd750.jpg?v=250703010154",
    "/media/7d0a2db2dcb347a38175d284849cd750-5d4835af.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/87b74c2f1b3141bd9fec49261ff86953.jpg?v=250703010154",
    "/media/87b74c2f1b3141bd9fec49261ff86953-d22a82a1.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/8a59e55176824556b0f62ac1346a3e76.jpg?v=250703010154",
    "/media/8a59e55176824556b0f62ac1346a3e76-3436c14b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/8d8c054cf2144ce88d71e5cf853a9ea1.jpg?v=250703010154",
    "/media/8d8c054cf2144ce88d71e5cf853a9ea1-f87202aa.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/91403019073048d1a21b3e2ba146a7df.jpg?v=250703010154",
    "/media/91403019073048d1a21b3e2ba146a7df-4d1254b3.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/9e58cf98682e4d108da18d0ab84b7eaa.jpg?v=250703010154",
    "/media/9e58cf98682e4d108da18d0ab84b7eaa-e9dd7e01.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/aef00cc87c1b45f982aee572b54ba451.jpg?v=250703010154",
    "/media/aef00cc87c1b45f982aee572b54ba451-7b9828ee.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/b70c52ac19a149b6aef86bc474d35342.jpg?v=250703010154",
    "/media/b70c52ac19a149b6aef86bc474d35342-5bf9abbd.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/b83eb2f3acd64ecc9af7534623535243.jpg?v=250703010154",
    "/media/b83eb2f3acd64ecc9af7534623535243-b6f12df9.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/b993a1ed6c9d40e8a8043926ca21aa97.jpg?v=250703010154",
    "/media/b993a1ed6c9d40e8a8043926ca21aa97-b14313a3.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/b9aa17b5a5354a7cafb273bab7e07729.jpg?v=250703010154",
    "/media/b9aa17b5a5354a7cafb273bab7e07729-aa0b8e48.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/be7c748ae8f64172a28da99c5740b173.jpg?v=250703010154",
    "/media/be7c748ae8f64172a28da99c5740b173-1e8f358c.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/cd97826f7f414ae98708e41b2355fed9.jpg?v=250703010154",
    "/media/cd97826f7f414ae98708e41b2355fed9-7fe602ee.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/d6d4ad4b31cf4d2f83ada2961aca5a4a.jpg?v=250703010154",
    "/media/d6d4ad4b31cf4d2f83ada2961aca5a4a-a5022045.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/299-1/1EA581549D41CAAF.jpg?v=250703010154",
    "/media/1EA581549D41CAAF-aabf2a8d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/299-1/55440806A227F04A.jpg?v=250703010154",
    "/media/55440806A227F04A-29d90857.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/299-1/7307AADF83C1DC6E.jpg?v=250703010154",
    "/media/7307AADF83C1DC6E-fbf0b20f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/299-1/83EA8FF1696EC1F5.png?v=250703010154",
    "/media/83EA8FF1696EC1F5-3a5f3b81.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/299-1/8A018BC960526BC9.jpg?v=250703010154",
    "/media/8A018BC960526BC9-64d97808.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/299-1/C66086EEE9A490FC.jpg?v=250703010154",
    "/media/C66086EEE9A490FC-4f3559be.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/299-1/D22C525EC8B4C038.png?v=250703010154",
    "/media/D22C525EC8B4C038-2fa7eb90.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/299-1/E663A8A8947DB1DE.jpg?v=250703010154",
    "/media/E663A8A8947DB1DE-445b554c.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/3923B236D387DF13.jpg?v=250703010154",
    "/media/3923B236D387DF13-4418a01f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/5043C9491BF736FA.jpg?v=250703010154",
    "/media/5043C9491BF736FA-62e1e85f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/6C95C511A1B0A56F.jpg?v=250703010154",
    "/media/6C95C511A1B0A56F-00b7615c.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/73DB5DA183E3E349.jpg?v=250703010154",
    "/media/73DB5DA183E3E349-a5322183.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/9203A94C1D87A5AB.jpg?v=250703010154",
    "/media/9203A94C1D87A5AB-742829f0.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/986567C21B9D4BE9.jpg?v=250703010154",
    "/media/986567C21B9D4BE9-f73ecdd2.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/316-179/97699D48F146467E.png?v=250703010154",
    "/media/97699D48F146467E-fbe62d6f.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/316-179/B574EA809D7233E3.png?v=250703010154",
    "/media/B574EA809D7233E3-9ef927be.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/316-179/C7E9714C8D40ED3A.jpg?v=250703010154",
    "/media/C7E9714C8D40ED3A-5e61ffb5.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/035AC0428128C5D3.jpg?v=250703010154",
    "/media/035AC0428128C5D3-44e56a84.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/7176694C9D7D6E35.jpg?v=250703010154",
    "/media/7176694C9D7D6E35-596a2495.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/A52035FFA5D1694A.jpg?v=250703010154",
    "/media/A52035FFA5D1694A-d2810319.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/D38A48F4A1717366.jpg?v=250703010154",
    "/media/D38A48F4A1717366-60387ade.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/D83A0704964F0D26.jpg?v=250703010154",
    "/media/D83A0704964F0D26-3a1cce8b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/D93445FA7ED53684.jpg?v=250703010154",
    "/media/D93445FA7ED53684-4be8902f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/E99A58F68BB80062.jpg?v=250703010154",
    "/media/E99A58F68BB80062-1f3f9fe7.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/ECD86FBDE56042F5.jpg?v=250703010154",
    "/media/ECD86FBDE56042F5-c4547264.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/FAAAD794879B944C.jpg?v=250703010154",
    "/media/FAAAD794879B944C-9d8f8a82.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/FC52664210011F8D.jpg?v=250703010154",
    "/media/FC52664210011F8D-8bb13ed5.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/3EBBD38474DDA34B.pdf?v=250703010154",
    "/docs/3EBBD38474DDA34B-b0295c63.pdf",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480-1/C7E9714C8D40ED3A.jpg?v=250703010154",
    "/media/C7E9714C8D40ED3A-5e61ffb5.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480-444/3022188EAC1C22A7.jpg?v=250703010154",
    "/media/3022188EAC1C22A7-423ac68d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480-444/A00B6AF75FD8059F.jpg?v=250703010154",
    "/media/A00B6AF75FD8059F-932f364d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480-444/CD796FE7DC940D7D.jpg?v=250703010154",
    "/media/CD796FE7DC940D7D-2f561c37.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/03ae691e81e7428ea9bf188273b1f4f0.jpg?v=250703010154",
    "/media/03ae691e81e7428ea9bf188273b1f4f0-091ee464.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/0414eb6074b44a4e9831872e13cb95d3.jpg?v=250703010154",
    "/media/0414eb6074b44a4e9831872e13cb95d3-fad8bf84.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/1736a794029f4a3ab916b09c43fbbe4e.jpg?v=250703010154",
    "/media/1736a794029f4a3ab916b09c43fbbe4e-51356e7e.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/1a6cac0340c641bbbcb5cdfd07de834e.jpg?v=250703010154",
    "/media/1a6cac0340c641bbbcb5cdfd07de834e-e115f5c2.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/1daff67ce1394398847eb6ce0b55b973.jpg?v=250703010154",
    "/media/1daff67ce1394398847eb6ce0b55b973-d73cdbed.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/1fa17e423bba4b84969af94cf41f7a37.jpg?v=250703010154",
    "/media/1fa17e423bba4b84969af94cf41f7a37-1e811224.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/20759260176b46979700db906d93d51b.jpg?v=250703010154",
    "/media/20759260176b46979700db906d93d51b-ab13e91e.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/21715703645b4f558cf40aa4beb5a523.jpg?v=250703010154",
    "/media/21715703645b4f558cf40aa4beb5a523-06ef7a22.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/218f3d8a44fc4899947ab9d60cbb06f4.png?v=250703010154",
    "/media/218f3d8a44fc4899947ab9d60cbb06f4-d7e4661a.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/21c48069f6e844fabc7d39bdcf978329.jpg?v=250703010154",
    "/media/21c48069f6e844fabc7d39bdcf978329-4ab82e28.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/23bc00ac02b145b4b06e1388a66f33a9.jpg?v=250703010154",
    "/media/23bc00ac02b145b4b06e1388a66f33a9-f2ff1e36.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/245f8a46e98d4b528706a8dbfee552ee.jpg?v=250703010154",
    "/media/245f8a46e98d4b528706a8dbfee552ee-6e9d338a.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/26b9563b45b941b0b0305b6902f0f09e.jpg?v=250703010154",
    "/media/26b9563b45b941b0b0305b6902f0f09e-def4f117.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/2c02f1c83f0e435f8d9a3ca79c218061.jpg?v=250703010154",
    "/media/2c02f1c83f0e435f8d9a3ca79c218061-a6ae0c56.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/3636742fe6274e6b9d1e7e0e0d86effc.jpg?v=250703010154",
    "/media/3636742fe6274e6b9d1e7e0e0d86effc-6961fccc.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/369e7b96ed5e405c815cdfb4a459e8d5.jpg?v=250703010154",
    "/media/369e7b96ed5e405c815cdfb4a459e8d5-e61eb170.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/463259f967c24848a5c4f1302007f7c9.jpg?v=250703010154",
    "/media/463259f967c24848a5c4f1302007f7c9-a077b71b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/4635f0917b1f424699746fbe576b7747.jpg?v=250703010154",
    "/media/4635f0917b1f424699746fbe576b7747-5335d1ee.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/46fa5635c0aa44a193a59aa915a27235.jpg?v=250703010154",
    "/media/46fa5635c0aa44a193a59aa915a27235-f2e21dab.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/471ef212eeb1411e9e7d8886b9fa2918.jpg?v=250703010154",
    "/media/471ef212eeb1411e9e7d8886b9fa2918-62978704.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/48fa7d2a425e473f836235b9b7415d59.jpg?v=250703010154",
    "/media/48fa7d2a425e473f836235b9b7415d59-53f90bb5.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/4a59434963f249c1b87f7b7a237a8bcb.jpg?v=250703010154",
    "/media/4a59434963f249c1b87f7b7a237a8bcb-a498ae9a.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/4dbd286653b64668a8b753e7a7b2270e.jpg?v=250703010154",
    "/media/4dbd286653b64668a8b753e7a7b2270e-19827ecb.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/4f3f3e17e6924eb4af6b64142f57a952.jpg?v=250703010154",
    "/media/4f3f3e17e6924eb4af6b64142f57a952-666fa14f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/4f699abba89f431d84179ab83890c98b.jpg?v=250703010154",
    "/media/4f699abba89f431d84179ab83890c98b-324ab2ef.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/52DF1BC131A54417.jpg?v=250703010154",
    "/media/52DF1BC131A54417-544a9373.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/5c7d3880f8ef4ae8a5dd11301d64062c.jpg?v=250703010154",
    "/media/5c7d3880f8ef4ae8a5dd11301d64062c-564601b3.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/64a4d28705f24d48bf6819d330c9c7b4.jpg?v=250703010154",
    "/media/64a4d28705f24d48bf6819d330c9c7b4-7feffd59.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/69a026ec569648ac894dfc18595c57ed.jpg?v=250703010154",
    "/media/69a026ec569648ac894dfc18595c57ed-de761fb5.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/69f45608656640d0ae319bcc5a23ba1e.jpg?v=250703010154",
    "/media/69f45608656640d0ae319bcc5a23ba1e-15e6906d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6ccbcc874a0044dba1cde18d19b4773f.jpg?v=250703010154",
    "/media/6ccbcc874a0044dba1cde18d19b4773f-3a9cee16.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6d80734917324aaeb148b209b0318086.jpg?v=250703010154",
    "/media/6d80734917324aaeb148b209b0318086-57fe3341.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6ed03eefd9e14ee4acb52809cbfa06d0.jpg?v=250703010154",
    "/media/6ed03eefd9e14ee4acb52809cbfa06d0-eebceee4.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6f27e384d84945b88e36bc876fc52c97.jpg?v=250703010154",
    "/media/6f27e384d84945b88e36bc876fc52c97-0d4825da.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6f31a47ee5f04f92a62233309239dce2.jpg?v=250703010154",
    "/media/6f31a47ee5f04f92a62233309239dce2-fe0ac00c.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6f583e3dabb94da2b33529de6544d2df.jpg?v=250703010154",
    "/media/6f583e3dabb94da2b33529de6544d2df-0eda29e7.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/79ffed439d624f9b81ff44d88736f0c7.jpg?v=250703010154",
    "/media/79ffed439d624f9b81ff44d88736f0c7-afc9b345.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/7b2ab0695d174358bef8f06c5eaffbdc.jpg?v=250703010154",
    "/media/7b2ab0695d174358bef8f06c5eaffbdc-ccfb5f05.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/81cc640ca9364a71aecc4bca205fe99d.jpg?v=250703010154",
    "/media/81cc640ca9364a71aecc4bca205fe99d-0145f1d7.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/83ac1d9eea0b4b31a2a3be9547e3a5cc.jpg?v=250703010154",
    "/media/83ac1d9eea0b4b31a2a3be9547e3a5cc-088a95fe.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/85124a75d62941feb3fabfd74414438a.jpg?v=250703010154",
    "/media/85124a75d62941feb3fabfd74414438a-3610996f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/87e3775dd95d412fa548c0969d778ee7.jpg?v=250703010154",
    "/media/87e3775dd95d412fa548c0969d778ee7-d7440204.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/99531fd845af42a4b75198ff05feb975.jpg?v=250703010154",
    "/media/99531fd845af42a4b75198ff05feb975-4036f0dc.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/998e359d89ee4511b60ac458a8c3423f.jpg?v=250703010154",
    "/media/998e359d89ee4511b60ac458a8c3423f-91248a1a.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/a005160f78fb41349117a037ea3754d1.jpg?v=250703010154",
    "/media/a005160f78fb41349117a037ea3754d1-dd066d1e.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/a4982d2b55174772977b94f1239f90a2.jpg?v=250703010154",
    "/media/a4982d2b55174772977b94f1239f90a2-c2f3ff11.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/a52d3dd4962a4174b5a3ef5f8eb84afd.jpg?v=250703010154",
    "/media/a52d3dd4962a4174b5a3ef5f8eb84afd-f54f131a.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/a6a567b0773f40e295265cd6a312e987.jpg?v=250703010154",
    "/media/a6a567b0773f40e295265cd6a312e987-7a43766f.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/aaf15cc826b543eb8eef491dec51f7a7.jpg?v=250703010154",
    "/media/aaf15cc826b543eb8eef491dec51f7a7-b1c12b2a.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ab78100b18954f8aaa15178240a44b08.jpg?v=250703010154",
    "/media/ab78100b18954f8aaa15178240a44b08-efeebbad.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ae49730624aa499cbb7be625422002ef.jpg?v=250703010154",
    "/media/ae49730624aa499cbb7be625422002ef-c651b3c4.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/aef3b46c0016408bbaea57a216bbf8ba.jpg?v=250703010154",
    "/media/aef3b46c0016408bbaea57a216bbf8ba-d0a3813a.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b0c03401679d4724b75c47ba2f4bbc7a.jpg?v=250703010154",
    "/media/b0c03401679d4724b75c47ba2f4bbc7a-e31fb743.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b0cf168617d34d58b74b127ddc25ca82.jpg?v=250703010154",
    "/media/b0cf168617d34d58b74b127ddc25ca82-903925e5.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b541ed15bf5746a585356e296c69846b.jpg?v=250703010154",
    "/media/b541ed15bf5746a585356e296c69846b-b5dc134d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b85639ebb1ca4a41aef00e14d73bf17f.jpg?v=250703010154",
    "/media/b85639ebb1ca4a41aef00e14d73bf17f-f99f3c05.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b893d1d9e7594c65aabf0dd0f54ebe7a.jpg?v=250703010154",
    "/media/b893d1d9e7594c65aabf0dd0f54ebe7a-af9db724.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/bdff0488439a4f0fae08b9e2191e6539.jpg?v=250703010154",
    "/media/bdff0488439a4f0fae08b9e2191e6539-3c420aef.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/c2054cc3794f45cab407c4b5833579e8.jpg?v=250703010154",
    "/media/c2054cc3794f45cab407c4b5833579e8-45b8cc2c.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/c5bacdd4790942fabacf6bc186a127f1.jpg?v=250703010154",
    "/media/c5bacdd4790942fabacf6bc186a127f1-53e1577b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/c8f2f695eace4cd3bf9844f5e5e3b53d.jpg?v=250703010154",
    "/media/c8f2f695eace4cd3bf9844f5e5e3b53d-41c7c73b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/cc359e3ff29c4d14a747f980987c3128.jpg?v=250703010154",
    "/media/cc359e3ff29c4d14a747f980987c3128-1430d021.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/cca93c5f0eea45ca91c1e60f0d41ff60.jpg?v=250703010154",
    "/media/cca93c5f0eea45ca91c1e60f0d41ff60-efddfeda.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/d7c6d8387bfc47dba5774b5554ebbca4.jpg?v=250703010154",
    "/media/d7c6d8387bfc47dba5774b5554ebbca4-eac9d926.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/d9db33d097a444e0802e0a8708928b9e.jpg?v=250703010154",
    "/media/d9db33d097a444e0802e0a8708928b9e-6bff1026.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/da6cc9fd3c024424a7e3b2bab1eec8fd.jpg?v=250703010154",
    "/media/da6cc9fd3c024424a7e3b2bab1eec8fd-94f8bdeb.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/de90f730b3ba491cb2c1f3954ca75d1c.jpg?v=250703010154",
    "/media/de90f730b3ba491cb2c1f3954ca75d1c-dead3ada.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/df5f8e8bcbd54398aad08afc367e0558.jpg?v=250703010154",
    "/media/df5f8e8bcbd54398aad08afc367e0558-9b9f2752.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e10005d26fe24b829f1f89b96c235141.jpg?v=250703010154",
    "/media/e10005d26fe24b829f1f89b96c235141-ee5d3a81.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e2d06720ae12423d86983a598c85ad49.jpg?v=250703010154",
    "/media/e2d06720ae12423d86983a598c85ad49-85953f2a.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e37f4ee33acd4ca0908b2f80a2e273df.jpg?v=250703010154",
    "/media/e37f4ee33acd4ca0908b2f80a2e273df-5b32dc0b.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e802ca8f682a41b79507f74f6b1d9960.jpg?v=250703010154",
    "/media/e802ca8f682a41b79507f74f6b1d9960-c54605dd.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e9d9d193025649b9b4fbe3b79010592b.jpg?v=250703010154",
    "/media/e9d9d193025649b9b4fbe3b79010592b-0130cba8.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ec822d2e6bdc4dd4ab1d92c8789da4b0.jpg?v=250703010154",
    "/media/ec822d2e6bdc4dd4ab1d92c8789da4b0-82ef71cd.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/f9ae15b5332649e69db6bbc7fc94fadc.jpg?v=250703010154",
    "/media/f9ae15b5332649e69db6bbc7fc94fadc-af3dbe31.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ffa2265f25a44efe8abd3d47c0830c02.jpg?v=250703010154",
    "/media/ffa2265f25a44efe8abd3d47c0830c02-3267f938.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ffc76b4ddb1c42bfa0d6cf360efbd4cd.jpg?v=250703010154",
    "/media/ffc76b4ddb1c42bfa0d6cf360efbd4cd-0f62096d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-287/5136C6CF547A1B3E.png?v=250703010154",
    "/media/5136C6CF547A1B3E-657ce187.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-287/75C5B88D8006F20E.png?v=250703010154",
    "/media/43B282B5793BF381-182a2b4c.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/0A808869AC9837AE.png?v=250703010154",
    "/media/0A808869AC9837AE-bb104151.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/0F987FB827A63B5A.png?v=250703010154",
    "/media/0F987FB827A63B5A-87126fc7.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/2C4A1E0822D7E62B.png?v=250703010154",
    "/media/2C4A1E0822D7E62B-914865f7.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/3142ACCB856306D9.png?v=250703010154",
    "/media/3142ACCB856306D9-bd94e936.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/3AC58331E2E636DD.png?v=250703010154",
    "/media/3AC58331E2E636DD-86fa6423.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/5372C84521BA060C.png?v=250703010154",
    "/media/5372C84521BA060C-b487b839.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/57572F304DAEF276.png?v=250703010154",
    "/media/57572F304DAEF276-76590424.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/63C41A415A23BA66.png?v=250703010154",
    "/media/63C41A415A23BA66-5f7725c5.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/B855F0141EA19544.png?v=250703010154",
    "/media/B855F0141EA19544-effa77e4.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/C4175C4342189500.png?v=250703010154",
    "/media/C4175C4342189500-e83af848.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/C5C7D90B761E975D.png?v=250703010154",
    "/media/C5C7D90B761E975D-4d7fe125.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/CDBAE38D3021F3E2.png?v=250703010154",
    "/media/CDBAE38D3021F3E2-fa9e021a.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-288/D3C0AA9344FF34AE.png?v=250703010154",
    "/media/D3C0AA9344FF34AE-588e90ea.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-290/0D4BB4B1C57F72CE.png?v=250703010154",
    "/media/0D4BB4B1C57F72CE-c8844ce8.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-290/37D753A0EFA3B7CC.png?v=250703010154",
    "/media/37D753A0EFA3B7CC-105e8e22.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-290/504344B68054989C.png?v=250703010154",
    "/media/504344B68054989C-cde35334.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-291/DF5C4ACD0FEF89CC.png?v=250703010154",
    "/media/DF5C4ACD0FEF89CC-b1ec7d43.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/608-291/F0DC60240063AB5E.png?v=250703010154",
    "/media/F0DC60240063AB5E-9484393b.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/623-1/03A91A24FE65F768.jpg?v=250703010154",
    "/media/03A91A24FE65F768-8048820e.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/623-1/D22C525EC8B4C038.png?v=250703010154",
    "/media/D22C525EC8B4C038-2fa7eb90.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/623-252/1665984D16977ACA.jpg?v=250703010154",
    "/media/1665984D16977ACA-d7278e85.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/623-252/FD49DA3A4CE65544.jpg?v=250703010154",
    "/media/FD49DA3A4CE65544-0a497c15.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/640-1225/CD796FE7DC940D7D.jpg?v=250703010154",
    "/media/CD796FE7DC940D7D-2f561c37.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/640-1564/A00B6AF75FD8059F.jpg?v=250703010154",
    "/media/A00B6AF75FD8059F-932f364d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/640-1673/3022188EAC1C22A7.jpg?v=250703010154",
    "/media/3022188EAC1C22A7-423ac68d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768-1/81624252C906CF4B.png?v=250703010154",
    "/media/81624252C906CF4B-07bb9476.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768-1/9D71733BDA54F440.png?v=250703010154",
    "/media/9D71733BDA54F440-710191f4.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768-1/D62F062CDDC68376.png?v=250703010154",
    "/media/D62F062CDDC68376-5db158dc.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/21715703645b4f558cf40aa4beb5a523.jpg?v=250703010154",
    "/media/21715703645b4f558cf40aa4beb5a523-06ef7a22.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/24b187cdb1d94461830f567c8452e0a3.jpg?v=250703010154",
    "/media/24b187cdb1d94461830f567c8452e0a3-70aa810a.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/464305d81e794a37af19fc37387aadeb.jpg?v=250703010154",
    "/media/464305d81e794a37af19fc37387aadeb-3bc9c361.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/4dbd286653b64668a8b753e7a7b2270e.jpg?v=250703010154",
    "/media/4dbd286653b64668a8b753e7a7b2270e-19827ecb.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/50e3627b1e8e416fb863b903e5e94a2c.jpg?v=250703010154",
    "/media/50e3627b1e8e416fb863b903e5e94a2c-656232bd.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/52DF1BC131A54417.jpg?v=250703010154",
    "/media/52DF1BC131A54417-544a9373.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/75200e940ada46d8ab07631027f780a8.jpg?v=250703010154",
    "/media/75200e940ada46d8ab07631027f780a8-2da89c62.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/a473086a1f7142cca5aba1a301b5f09d.png?v=250703010154",
    "/media/a473086a1f7142cca5aba1a301b5f09d-49c2fc9a.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/acece4f0cfa54979a86f048847277555.jpg?v=250703010154",
    "/media/acece4f0cfa54979a86f048847277555-3be0ae9d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/c1e53979bb7f41b18d2f71726549e1b7.jpg?v=250703010154",
    "/media/c1e53979bb7f41b18d2f71726549e1b7-96e367e4.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/df9689e037cc40209d77fa74994da29e.jpg?v=250703010154",
    "/media/df9689e037cc40209d77fa74994da29e-1fd72eeb.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/f9ae15b5332649e69db6bbc7fc94fadc.jpg?v=250703010154",
    "/media/f9ae15b5332649e69db6bbc7fc94fadc-af3dbe31.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/f9d7ab097dea4855a65b6d77ef4134cd.jpg?v=250703010154",
    "/media/f9d7ab097dea4855a65b6d77ef4134cd-2a9c0856.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/EB26FCBE71769ED4.pdf?v=250703010154",
    "/docs/EB26FCBE71769ED4-cc99ddaf.pdf",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/FA26DEF0263E47FD.pdf?v=250703010154",
    "/docs/FA26DEF0263E47FD-1f65d714.pdf",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/o/2178B529A70C288D.png?v=250703010154",
    "/media/2178B529A70C288D-49fa0f34.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/1064-1256-1064-1252-0-0/527c407a23a449aab5cdf572deb10aad.jpg?v=250703010154",
    "/media/527c407a23a449aab5cdf572deb10aad-4f1392e6.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/1104-1104-916-1100-88-0/d5f8154a88d6416e8ff83d93507d893b.jpg?v=250703010154",
    "/media/d5f8154a88d6416e8ff83d93507d893b-aa8c8ef5.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/148-144-120-136-12-0/5487AACD7B5205AC.png?v=250703010154",
    "/media/5487AACD7B5205AC-0249dbdd.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/1744-1748-1092-1700-316-8/C7E9714C8D40ED3A.jpg?v=250703010154",
    "/media/C7E9714C8D40ED3A-5e61ffb5.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/188-188-156-176-16-0/5487AACD7B5205AC.png?v=250703010154",
    "/media/5487AACD7B5205AC-0249dbdd.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/216-216-216-208-0-0/5487AACD7B5205AC.png?v=250703010154",
    "/media/5487AACD7B5205AC-0249dbdd.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/216-216-216-216-0-0/5487AACD7B5205AC.png?v=250703010154",
    "/media/5487AACD7B5205AC-0249dbdd.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/224-224-224-224-0-0/C6CC3924F597CC1C.png?v=250703010154",
    "/media/C6CC3924F597CC1C-6aa44aa8.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/2556-1436-896-1436-832-0/B08C6DDD1B097C14.png?v=250703010154",
    "/media/B08C6DDD1B097C14-f3a87198.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/320-304-240-304-36-0/D2443DE85E36EE48.png?v=250703010154",
    "/media/D2443DE85E36EE48-92dbbd15.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/376-376-376-364-0-4/e422613ef71e48739e102d8670cf5594.jpg?v=250703010154",
    "/media/e422613ef71e48739e102d8670cf5594-201855c4.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/480-678-480-678-0-0/CDDA8C85472B6810.png?v=250703010154",
    "/media/CDDA8C85472B6810-921f350c.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/480-678-480-678-0-0/F1AC14E3BB015198.png?v=250703010154",
    "/media/F1AC14E3BB015198-e3b755f2.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/593-839-593-836-0-1/b3bc4dddc9f248a8b3200fd079f712e5.jpg?v=250703010154",
    "/media/b3bc4dddc9f248a8b3200fd079f712e5-f39fddee.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/596-844-595-836-0-4/117fe18fbca541c89c710d8ab2ec33fc.jpg?v=250703010154",
    "/media/117fe18fbca541c89c710d8ab2ec33fc-12f7172d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/598-545-594-545-1-0/69433b2a641445ec80c3a158bea45ec4.jpg?v=250703010154",
    "/media/69433b2a641445ec80c3a158bea45ec4-add8d78e.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/675-375-675-375-0-0/e055338776c14470bbdd2d9e5e8872b9.jpg?v=250703010154",
    "/media/e055338776c14470bbdd2d9e5e8872b9-170a07ad.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/675-380-675-375-0-2/534711c788dc4eba8588a2194d64a4ce.gif?v=250703010154",
    "/media/534711c788dc4eba8588a2194d64a4ce-12fece88.gif",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/675-380-675-375-0-2/5f9cf246b4a741debcfa7e8aaf9c5a11.gif?v=250703010154",
    "/media/5f9cf246b4a741debcfa7e8aaf9c5a11-67a44a70.gif",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/675-380-675-375-0-2/69ae6712cbdb42e2849186e207b76212.gif?v=250703010154",
    "/media/69ae6712cbdb42e2849186e207b76212-83afa1e8.gif",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/675-380-675-375-0-2/a13bb2b76b8845049db70df098d1109a.jpg?v=250703010154",
    "/media/a13bb2b76b8845049db70df098d1109a-e1ba87e0.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/675-380-675-375-0-2/c29aa4b7a39e4754bd600c6db916ee4f.jpg?v=250703010154",
    "/media/c29aa4b7a39e4754bd600c6db916ee4f-18aae6a3.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/678-381-675-375-0-1/14875D222AE67E62.jpg?v=250703010154",
    "/media/14875D222AE67E62-596709b3.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/678-381-675-375-0-1/49F5938C8B099B30.jpg?v=250703010154",
    "/media/49F5938C8B099B30-e4aa4c96.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/678-381-675-375-0-1/E6555E21A312AF35.jpg?v=250703010154",
    "/media/E6555E21A312AF35-3cc3d10d.jpg",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/736-256-736-224-0-16/C8DC790D2EEC182B.png?v=250703010154",
    "/media/C8DC790D2EEC182B-146beb5d.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/796-236-736-236-28-0/DD8F2FFC8B2A5377.png?v=250703010154",
    "/media/DD8F2FFC8B2A5377-d9626046.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/898-505-898-425-0-40/43B282B5793BF381.png?v=250703010154",
    "/media/43B282B5793BF381-182a2b4c.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/898-505-898-425-0-40/6A75D2BA39B71C0C.png?v=250703010154",
    "/media/5136C6CF547A1B3E-657ce187.png",
  ],
  [
    "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/r/941-453-941-279-0-87/2f2639b38db34135bca9c5fa4cc4f3be.jpg?v=250703010154",
    "/media/2f2639b38db34135bca9c5fa4cc4f3be-02bd787d.jpg",
  ],
]);

/** Local path for an old-site URL; unknown URLs pass through unchanged. */
export function asset(originalUrl: string): string {
  const key = originalUrl.startsWith("//")
    ? `https:${originalUrl}`
    : originalUrl;
  return ASSETS.get(key) ?? originalUrl;
}
